"use client";

import { c as _c } from "react/compiler-runtime";
import { showToast } from "@/lib/toast";
import { type ConnectorType } from "@/stores/connectorsStore";
import { useCallback, useState } from "react";
import { usePipedreamClient } from "./usePipedreamClient";
export interface PipedreamConnectResult {
  accountId: string;
  connectorType: ConnectorType;
}
interface UsePipedreamConnectResult {
  isConnecting: boolean;
  connectingType: string | null;
  pendingConnection: PipedreamConnectResult | null;
  connect: (connectorType: ConnectorType) => Promise<void>;
  clearPendingConnection: () => void;
}

/**
 * Hook to handle Pipedream OAuth flow for the connectors page.
 * After successful OAuth, stores pending connection data for the modal to finalize.
 */
export function usePipedreamConnect() {
  const $ = _c(8);
  const [connectingType, setConnectingType] = useState(null);
  const [pendingConnection, setPendingConnection] = useState(null);
  const {
    isConnecting,
    connectAccount
  } = usePipedreamClient();
  let t0;
  if ($[0] !== connectAccount) {
    t0 = async connectorType => {
      const appSlug = connectorType.providerConfig?.appSlug;
      if (!appSlug) {
        showToast.error("No app configured for this connector type");
        return;
      }
      setConnectingType(connectorType.type);
      const result = await connectAccount({
        appSlug,
        waitForClose: true
      });
      if (result) {
        await new Promise(_temp);
        setPendingConnection({
          accountId: result.accountId,
          connectorType
        });
      }
      setConnectingType(null);
    };
    $[0] = connectAccount;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const connect = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setPendingConnection(null);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const clearPendingConnection = t1;
  let t2;
  if ($[3] !== connect || $[4] !== connectingType || $[5] !== isConnecting || $[6] !== pendingConnection) {
    t2 = {
      isConnecting,
      connectingType,
      pendingConnection,
      connect,
      clearPendingConnection
    };
    $[3] = connect;
    $[4] = connectingType;
    $[5] = isConnecting;
    $[6] = pendingConnection;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp(resolve) {
  return setTimeout(resolve, 100);
}